import { Body, Observer, Equator, Horizon, MoonPhase, Illumination } from 'astronomy-engine';

export const MILESTONES = new Set(['Dawn', 'Sunrise', 'Latest Shema', 'Latest Shacharit', 'Midday', 'Earliest Minchah', 'Sunset', 'Nightfall']);

// Pure, offline astronomy. Never used to decide the liturgy or a halachic time.
export function skyState(instant, location) {
  const date = new Date(instant);
  if (!Number.isFinite(+date) || !location || !Number.isFinite(location.latitude) || !Number.isFinite(location.longitude)
    || Math.abs(location.latitude) > 90 || Math.abs(location.longitude) > 180) throw new RangeError('Invalid sky observer');
  const observer = new Observer(location.latitude, location.longitude, 0);
  const position = body => {
    const eq = Equator(body, date, observer, true, true);
    const h = Horizon(date, observer, eq.ra, eq.dec, 'normal');
    return { azimuth: h.azimuth, altitude: h.altitude, aboveHorizon: h.altitude >= 0 };
  };
  const sun = position(Body.Sun), moon = position(Body.Moon);
  const phase = MoonPhase(date), illumination = Illumination(Body.Moon, date).phase_fraction;
  const phaseName = phase < 10 || phase >= 350 ? 'New moon' : phase < 80 ? 'Waxing crescent' : phase < 100 ? 'First quarter'
    : phase < 170 ? 'Waxing gibbous' : phase < 190 ? 'Full moon' : phase < 260 ? 'Waning gibbous' : phase < 280 ? 'Last quarter' : 'Waning crescent';
  return { instant: date.toISOString(), observer: { ...location }, sun, moon: { ...moon, phase, illumination, phaseName },
    lighting: sun.altitude >= 6 ? 'day' : sun.altitude >= -6 ? (sun.azimuth < 180 ? 'dawn' : 'dusk') : 'night' };
}

// Use calendar-provided instants verbatim. Tomorrow is requested only if needed.
export function upcomingZmanim(instant, today, tomorrow) {
  const now = +new Date(instant);
  const select = info => (info?.values || []).filter(item => MILESTONES.has(item.label) && Number.isFinite(Date.parse(item.value)) && Date.parse(item.value) > now);
  let items = select(today);
  if (!items.length && tomorrow) items = select(tomorrow());
  return items.sort((a, b) => Date.parse(a.value) - Date.parse(b.value));
}

export function moonPath(phase, radius = 6) {
  // Illuminated disk bounded by the limb and elliptical terminator, north up.
  const waxing = phase <= 180, k = Math.cos(phase * Math.PI / 180);
  const side = waxing ? 1 : 0, terminator = k >= 0 ? 1 - side : side;
  return `M 0 ${-radius} A ${radius} ${radius} 0 0 ${side} 0 ${radius} A ${Math.max(.001, Math.abs(k) * radius)} ${radius} 0 0 ${terminator} 0 ${-radius} Z`;
}
